import { apiClient, ApiClientConfig } from "api";
import { axiosInstance } from "api/axios-instance";
import { apiClientV3 } from "api/clientV3";
import { apiClientExport } from "api/export.client";
import { CONFIG } from "config";
import { AnyARecord } from "dns";
import { EventsParams, EventsResponse, UpdateShowHideDTO } from "features/events";
import { ItemSales } from "types/items-sales";


export type ItemSalesResponse = PaginatedResponse<ItemSales>;

type ParticipateQueryParams = {
  participant_id?: string;
  invoice_id?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  event_name?: string;
  order_by?: string;
  size?: number;
  page?: number;
};

export interface ParticipateResponce {
  participant_id: string;
  invoice_id: string;
  first_name: string;
  last_name: string;
  email: string;
  event_name: string;
}

export interface PaginatedResponse<T> {
  data: any;
  page: number;
  size: number;
  pages: number;
  total: number;
  items: T[];
}

type Participant = {
  participant_id: number;
  label_name: string;
  label_value: string;
};

type ParticipantList = {
  participant_id: number;
  first_name: string;
  last_name: string;
  price: number;
  category_name: string;
  category_name_arabic: string;
  booking_type: string;
  email_address: string;
  event_name: string;
  seatamount: number;
  seatnumber: any;

  participant_list: Participant[];
  tshirt_size: string;
  refund_protect_price: number;
  image_url: string;
  age: number;
  currency_name: string;
};

type EventDetail = {
  event_id: number;
  event_date: string | null;
  event_name: string;
  event_name_arabic: string;
  receipt_image_url: string;
  category_name: string;
  image_url: string;
};

export type InvoiceDetailsResponse = {
  id: string;
  invoice_no: string;
  total_price: number;
  order_date: string;
  phone_number: string | null;
  email_address: string;
  booking_status: string;
  payment_status: string;
  full_name: string;
  payment_method: string;
  event_detail: EventDetail;
  delivery_address: any;
  all_participant: ParticipantList[];
  item_list: any[];
  refund_booking_amount: any;
  total_addons: any;
  total_discount: any;
  total_item_price: any;
  total_participant_price: any;
  total_cost_with_discount:any;
  delivery_price: any;
  refundable_amount: any;
  currency_type:any;
  sub_total: any
  category: string | null;
  isBulkGroupregistration :string
};


export type WalletsDTO = {
  id?: string;
  email: string;
  name: string;
  description: string;
  amount: number;
  customer_id: string;
  first_name: string;
  last_name: string;
  mobile_no: string;
}

export type paymentLinkDTO = {
  booking_id: string;
  source: string
}

export type confirmPayDTO = {
  bulkid: number;
}

export type ParticipateListResponse = PaginatedResponse<ParticipateResponce>;

export const TransectionApiServices = () => {

  const getParticipateList = async (
    params: ParticipateQueryParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<ParticipateListResponse>({
      ...callConfig,
      endpoint: `/admin/participant/participant`,
      params,
    });

    return response.data;
  };

  const updateParticipant = async (payload: UpdateShowHideDTO) => {
    const response = await apiClient({
      endpoint: `/participant/updateformsvalue`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  const getParticiPantdetails = async (
    id: string,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `/admin/participant/participantdetails?${id}`,
    });

    return response.data;
  };


  const getInvoiceList = async (
    flag: string,
    params: ParticipateQueryParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<ParticipateListResponse>({
      ...callConfig,
      endpoint: `/admin/participant/invoicelist?Flag=${flag}`,
      params,
    });

    return response.data;
  };

  // const exportInvoiceList = async (
  //   params: ParticipateQueryParams,
  //   callConfig?: Partial<ApiClientConfig>,
  // ) => {
  //   const response = await apiClient<ParticipateListResponse>({
  //     ...callConfig,
  //     endpoint: `/admin/participant/downloadinvoicelist`,
  //     params,
  //   });

  //   return response.data;
  // };

  const replaceSubstring = (
    input: string,
    target: string,
    replacement: string,
  ): string => {
    const startIndex = input.indexOf(target);
    const endIndex = startIndex + target.length;
    const replacedStr =
      input.slice(0, startIndex) + replacement + input.slice(endIndex);

    return replacedStr;
  };

  const exportInvoiceList = async () => {
    // Replace baseUrl for Sports API if the request is for Sports APIs..
    const sportsService = replaceSubstring(
      CONFIG.SUFFIX_API_BASE_URL,
      '/identity/',
      '/events/',
    );
    const response = await axiosInstance.get(
      `${sportsService}/v1/admin/participant/downloadinvoicelist`,
      {
        responseType: 'blob',
      },
    );

    return response;
  };

  const getInvoiceDetails = async (
    id: string,
  ) => {
    // const response = await apiClient<InvoiceDetailsResponse>({
    //   endpoint: `/events/getorderdetails/${id}`,
    // });
     const response = await apiClientV3<InvoiceDetailsResponse>({
      endpoint: `/receipt/getorderdetails/${id}`,
    });

    return response.data;
  };

  // const exportPrticipants = async (params: { [key: string]: any }) => {
  //   const sportsService = replaceSubstring(
  //     CONFIG.SUFFIX_API_BASE_URL,
  //     '/identity/',
  //     '/events/',
  //   );
  //   const filteredParams = Object.fromEntries(
  //     Object.entries(params).filter(([_, value]) => value != null && value !== "")
  //   );
  //   const queryParams = new URLSearchParams(filteredParams);
  //   const response = await axiosInstance.get(
  //     `${sportsService}/v1/admin/participant/downloadparticipantlist?${queryParams.toString()}`,

  //     {
  //       responseType: 'blob',
  //     },
  //   );

  //   return response;
  // };


  const getDropDownList = async (Flag: any) => {
    const response = await apiClient({
      endpoint: `/admin/dropdownlist?${Flag}`
    })

    return response.data
  }

  const getBulkUploadEvent = async () => {
    const response = await apiClient({
      endpoint: `/events`
    })

    return response.data
  }

  const getSampleExcel = async (id: any) => {
    const response = await apiClient({
      endpoint: `/admin/events/getexcelsample?event_id=${id}`
    })

    return response.data
  }
  // const getSampleExcel = async (id: any) => {
  //   // Replace baseUrl for Sports API if the request is for Sports APIs..
  //   const sportsService = replaceSubstring(
  //     CONFIG.SUFFIX_API_BASE_URL,
  //     '/identity/',
  //     '/events/',
  //   );
  //   const response = await axiosInstance.get(
  //     `${sportsService}/v1/reports/downloadexcelfile/${id}`,
  //     {
  //       responseType: 'blob',
  //     },
  //   );

  //   return response;
  // };

  const uploadBulkExcel = async (formData: FormData) => {
    // Replace baseUrl for Sports API if the request is for Sports APIs..
    const sportsService = replaceSubstring(
      CONFIG.SUFFIX_API_BASE_URL,
      '/identity/',
      '/events/',
    );

    const response = await axiosInstance.post(
      `${sportsService}/v3/bulkupload/importexcel

`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };


  const getWalletList = async (
    params: ParticipateQueryParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<ParticipateListResponse>({
      ...callConfig,
      endpoint: `/admin/wallets/userwallets`,
      params,
    });

    return response.data;
  };

  const getUsers = async (email: string) => {
    const response = await apiClient({
      endpoint: `/admin/users?roles=User&page=1&size=10&email=${email}`
    })

    return response.data
  }

  const createWallet = async (payload: WalletsDTO) => {
    const response = await apiClient({
      endpoint: `admin/wallets/create`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  const sendInvoice = async (id: any, payload: any) => {
    const response = await apiClient({
      endpoint: `transactions/receiptnotification?order_no=${id}`,
      method: 'GET',
      data: payload,
    });

    return response.data;
  };

  const getBulkUploadList = async (
    params: ParticipateQueryParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<ParticipateListResponse>({
      ...callConfig,
      endpoint: `/bulkupload/getbulkuplodlist`,  // if any error then uncomment
      // endpoint: `/bulkupload/getbulkuplodlistforadmin`,
      params,
    });

    return response.data;
  };


  const getUploadDetails = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
    origin?:string
  ) => {
    const response = await apiClientV3<EventsResponse>({
      ...callConfig,
      endpoint: `/admin/${origin}/getbulkuplaoddetais/${params.id}/${params?.eventId}/${params.page}/${params.size}/admin`,

    });

    return response.data;
  };
  const BulkGroupRegistrationBooking = async (payload: any,action:string) => {
  const response = await apiClientV3({
    endpoint: `bookings/${action}`,
    method: 'POST',
    data: payload,
  });

  return response.data;
};
  const GroupRegistrationBooking = async (payload: any) => {
  const response = await apiClientV3({
    endpoint: 'bookings/CreateGroupRegistgrationBooking',
    method: 'POST',
    data: payload,
  });

  return response.data;
};

  const confirmPaymentBulk = async (payload: confirmPayDTO) => {
    const response = await apiClient({
      endpoint: `/bulkupload/confirmpayment`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };


  const getWaitingList = async (
    params: ParticipateQueryParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<ParticipateListResponse>({
      ...callConfig,
      endpoint: `/admin/participant/waitingparticipantinvoicelist`,
      params,
    });

    return response.data;
  };

  const createPaymentLink = async (payload: paymentLinkDTO) => {
    const response = await apiClient({
      endpoint: `/bookings/createlinkforwaitingparticipant`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };


  const rejectPayment = async (payload: any) => {
    const response = await apiClient({
      endpoint: `/admin/participant/rejectwaitinglist`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  const getReportsList = async (
    params: ParticipateQueryParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<ParticipateListResponse>({
      ...callConfig,
      endpoint: `/admin/participant/getexportreports`,
      params,
    });

    return response.data;
  };

    const getRefundList = async (
    params: ParticipateQueryParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_SUFFIX_EVENTS_API_BASE_URL;
    const response = await apiClient<ParticipateListResponse>({
      ...callConfig,
      endpoint: `${baseURL}/v2/admin/eventpostpone/bookingrefundlist`,
      params,
    });

    return response.data;
  };
   const createApproveandReject = async (payload: paymentLinkDTO) => {
    const baseURL = process.env.REACT_APP_SUFFIX_EVENTS_API_BASE_URL;
    const response = await apiClient({
      endpoint: `${baseURL}/v2/admin/eventpostpone/approverejectbookingrefund`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };


  // eventpostpone/approverejectbookingrefund

  const exportFinancialRequest = async (params: { [key: string]: any }) => {
    const sportsService = replaceSubstring(
      CONFIG.SUFFIX_API_BASE_URL,
      '/identity/',
      '/events/',
    );
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([ value]) => value != null && value !== "")
    );
    const queryParams = new URLSearchParams(filteredParams);
    const response = await axiosInstance.get(
      `${sportsService}/v1/admin/participant/TakeReportResuest?${queryParams.toString()}`,
    );

    return response.data;
  };
  const applyCouponBulk = async (payload: any,origin:string,name:string) => {
    const response = await apiClientV3({
      endpoint: `/${origin}/${name}`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

    const getcommonDropDown = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `admin/agentevent/getcommondropdownlist`,
      params,
    });

    return response.data;
  };

  const removeCouponBulk = async (payload: any,origin:string) => {
  const response = await apiClientV3({
      endpoint: `/${origin}/updatestatus`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
const removeCouponBulk1 = async (payload: any,origin:any) => {
    const response = await apiClient({
      endpoint: `${origin}/updatestatus`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  const getItemSalesList = async (
    params: ParticipateQueryParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<ItemSalesResponse>({
      ...callConfig,
      endpoint: `/admin/itemsales/invoicelist`,
      params,
    });

    return response.data;
  };


  const getItemSalesDetails = async (
    params: EventsParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<EventsResponse>({
      ...callConfig,
      endpoint: `/admin/itemsales/orderdetails`,
      params,
    });

    return response.data;
  };
 
  //   const removeParticipantlist = async (participant_id: any) => {
  //   const response = await apiClient({
  //     endpoint: `/bulkupload/removeparticipant/${participant_id}`,
  //     method: 'GET',
  //   });

  //   return response.data;
  // };
 const removeParticipantlist = async (origin:any,participant_id: any,bulk_upload_id:any,event_id:any) => {
    const response = await apiClientV3({
      endpoint: `/${origin}/removeparticipant?id=${participant_id}&bulk_upload_id=${bulk_upload_id}&event_id=${event_id}`,
      method: 'GET',
    });

    return response.data;
  };

  const updateItemsStatus = async (payload: any) => {
    const response = await apiClient({
      endpoint: `/admin/itemsales/updateitemorderstatus`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
   const UpdaterefundpostponedetailsStatus = async (payload: any) => {
    const baseURL = process.env.REACT_APP_SUFFIX_EVENTS_API_BASE_URL;
    const response = await apiClient({
      endpoint: `${baseURL}/v2/admin/eventpostpone/addupdaterefundpostponedetails`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  const acceptWaitingPayment = async (payload: any) => {
    const response = await apiClient({
      endpoint: `/bookings/AcceptPaymentForWaitingParticipant`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };


  const invoiceListRefresh = async (payload: any) => {
    const response = await apiClient({
      endpoint: `/bookings/checkpaymentstatus`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };


  const getExpoBoothList = async (
    params: ParticipateQueryParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<ParticipateListResponse>({
      ...callConfig,
      endpoint: `/admin/expobooth/getregisteredbooths`,
      params,
    });

    return response.data;
  };


  const updateExpoBoothNo = async (payload: AnyARecord) => {
    const response = await apiClient({
      endpoint: `admin/expobooth/bootheditdelete`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  const generatePaymentLinkBoot = async (payload: any) => {
    const response = await apiClient({
      endpoint: `admin/expobooth/generateboothpaymentlink`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  // const getExpoBoothParticiPantDetails = async (
  //   id: string,
  //   callConfig?: Partial<ApiClientConfig>,
  // ) => {
  //   const response = await apiClient<any>({
  //     ...callConfig,
  //     endpoint: `/admin/ExpoBooth/GetBoothParticipantDetails?${id}`,
  //   });

  //   return response.data;
  // };

  const getExpoBoothParticiPantDetails = async (id: any, pageFlag: string) => {
    // Replace baseUrl for Sports API if the request is for Sports APIs..
    const sportsService = replaceSubstring(
      CONFIG.SUFFIX_API_BASE_URL,
      '/identity/',
      '/events/',
    );
    const response = await axiosInstance.get(
      `${sportsService}/v2/admin/expobooth/getboothparticipantdetails/${id}/${pageFlag}`
    );

    return response;
  };

  // const getSendEmail = async (
  //   params: ParticipateQueryParams,
  //   callConfig?: Partial<ApiClientConfig>,
  // ) => {
  //   const response = await apiClient<ParticipateListResponse>({
  //     ...callConfig,
  //     endpoint: `/sendparticipantemail/spe`,
  //     params,
  //   });

  //   return response.data;
  // };

  const getSendEmail = async (payload: any) => {
    const response = await apiClient({
      endpoint: `/sendparticipantemail/spe?participant_id=${payload.participant_id}`,
      // method: 'GET',
    });

    return response.data;
  };

  const getBulkUploadEventList = async (Flag: any) => {
    const response = await apiClient({
      endpoint: `/admin/dropdownlist?${Flag}`
    })

    return response.data
  };


  const getTicketSelectionList = async (
    params: ParticipateQueryParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<ParticipateListResponse>({
      ...callConfig,
      endpoint: `/admin/expobooth/getregisteredboothforlayout`,
      params,
    });

    return response.data;
  };

  const updateTicketSheethNo = async (payload: any) => {
    const response = await apiClient({
      endpoint: `admin/expobooth/updateseatnumber`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  const getGroupNameListByEventId = async (Flag: any) => {
    const response = await apiClient({
      endpoint: `bulkupload/getgrouplist_byeventid?${Flag}`
    })
    
   
    return response.data
  }

  //   const exportGroupListByEventId = async (Flag: any) => {
  //   const response = await apiClient({
  //     endpoint: `bulkupload/getgroupregistrationparticipantexcelreport?${Flag}`
  //   })
    
  //   console.log('response.data'+JSON.stringify(response.data));
  //   return response.data
  // }

  const exportGroupListByEventId = async (Flag: any) => {
  const response = await apiClientExport({
    endpoint: `bulkupload/getgroupregistrationparticipantexcelreport?${Flag}`,
    method: 'GET',
    responseType: 'blob', // 👈 this is very important
   });


  // create a blob URL and auto-download
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;

  // optional: set a default filename if your API doesn’t send Content-Disposition
  link.setAttribute('download', 'GroupRegistrationReport.xlsx');

  document.body.appendChild(link);
  link.click();

  // cleanup
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
// const exportGroupListRegistraionByEventId = async (Type: any) => {
//   const response = await apiClientExport({
//     endpoint: `admin/participant/takereportresuest?${Type}`,
//     method: 'GET',
//     responseType: 'blob', // 👈 this is very important
//    });

//   return response.data;
//   // create a blob URL and auto-download
//   // const url = window.URL.createObjectURL(new Blob([response.data]));
//   // const link = document.createElement('a');
//   // link.href = url;

//   // link.setAttribute('download', 'GroupRegistrationReport.xlsx');

//   // document.body.appendChild(link);
//   // link.click();

//   // document.body.removeChild(link);
//   // window.URL.revokeObjectURL(url);
// };
 const exportGroupListRegistraionByEventId = async (params: { [key: string]: any }) => {
    const sportsService = replaceSubstring(
      CONFIG.SUFFIX_API_BASE_URL,
      '/identity/',
      '/events/',
    );
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([ value]) => value != null && value !== "")
    );
    const queryParams = new URLSearchParams(filteredParams);
    const response = await axiosInstance.get(
      `${sportsService}/v1/admin/participant/takereportresuest?${queryParams.toString()}`,
    );

    return response.data;
  };
 
// ✅ features/transaction_list/use-cases/get-wallets-report.ts

  const getWalletReportDownload = async () => {
  const response = await apiClientExport({
    endpoint: `admin/wallets/userwalletreport`,
    method: 'GET',
    responseType: 'blob', // 👈 this is very important
   });

  // create a blob URL and auto-download
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;

  // optional: set a default filename if your API doesn’t send Content-Disposition
  link.setAttribute('download', 'Wallet_report.xlsx');

  document.body.appendChild(link);
  link.click();

  // cleanup
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

  
  return {
    getParticipateList,
    getParticiPantdetails,
    updateParticipant,
    getInvoiceList,
    exportInvoiceList,
    getInvoiceDetails,
    getRefundList,
    // exportPrticipants,
    getDropDownList,
    getSampleExcel,
    uploadBulkExcel,
    getWalletList,
    getUsers,
    createWallet,
    sendInvoice,
    getBulkUploadList,
    getUploadDetails,
    getBulkUploadEvent,
   BulkGroupRegistrationBooking,
   GroupRegistrationBooking,
   removeParticipantlist,
    confirmPaymentBulk,
    getWaitingList,
    createPaymentLink,
    rejectPayment,
    getReportsList,
    exportFinancialRequest,
    applyCouponBulk,
    removeCouponBulk,
    getItemSalesList,
    getItemSalesDetails,
    updateItemsStatus,
    acceptWaitingPayment,
    invoiceListRefresh,
    getExpoBoothList,
    updateExpoBoothNo,
    generatePaymentLinkBoot,
    getExpoBoothParticiPantDetails,
    getSendEmail,
    getBulkUploadEventList,
    getTicketSelectionList,
    updateTicketSheethNo,
    createApproveandReject,
    UpdaterefundpostponedetailsStatus,
    getGroupNameListByEventId,
    exportGroupListByEventId,
    exportGroupListRegistraionByEventId,
    getWalletReportDownload,
    getcommonDropDown,
    removeCouponBulk1
  }
}






